
import { Component } from '@wordpress/element';
const {
    Placeholder
} = wp.components;
import {
    RichText,
} from '@wordpress/block-editor';
/**
 * Icons
 */
import icons from './icons.js';
/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';
/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';
class MoMoAutoContentGenerator extends Component {
    constructor(props, context, attributes) {
        super(props, context);
        this.content = '';
    }
    render() {
        const { attributes, setAttributes } = this.props;console.log(attributes);
        let oldContent = false;
        let options = this.props.options;
        let message = momoacg_block_admin.block_help;
        if ( 'contentGenerated' in options && true === options.contentGenerated ) {
            oldContent = true;
        } else {
            oldContent = false;
        }
        return (
            <div>
                { false === oldContent &&
                    <Placeholder
                    icon={icons.content}
                    label={ __('Auto Content Generator', 'momoacg') }
                    instructions= { message }
                    isColumnLayout
                    >
                    </Placeholder>
                }
                { true === oldContent &&
                    <RichText
                    value={options.generatedContent}
                    allowedFormats={ [ 'core/bold', 'core/italic' ] }
                    onChange={ ( content ) => this.setAttributes( { generatedContent, content } ) }
                    />
                }
            </div>
        );
    }
}
export default MoMoAutoContentGenerator;